import { useMcpTool } from "../lib/useMcpTool";
import McpCard from "../components/McpCard";
import { PanelScroll } from "./ClientsPanel";

interface Comm { direction?: string; channel?: string; contact?: string; preview?: string; body?: string; ts?: string; timestamp?: string; [k: string]: unknown }

export default function PersonalPanel() {
  const comms = useMcpTool<{ rows?: Comm[] } | Comm[]>("personal", "recent_communications", { limit: 25 });
  const rows: Comm[] = Array.isArray(comms.data) ? comms.data : (comms.data?.rows ?? []);
  return (
    <PanelScroll accentVar="--biome-personal" title="Personal" subtitle="private surface · sage-personal">
      <McpCard title={`Recent communications${rows.length ? ` (${rows.length})` : ""}`} loading={comms.loading} error={comms.error} onRefresh={comms.refresh} accentVar="--biome-personal">
        {rows.length === 0 ? (
          <div className="text-body-sm text-text-dim">No recent communications.</div>
        ) : (
          <div className="space-y-2">
            {rows.map((c, i) => (
              <div key={i} className="flex gap-3 text-body-sm border-b last:border-0 pb-2">
                <span className="font-mono text-caption text-text-dim w-16 shrink-0">{c.channel ?? c.direction ?? ""}</span>
                <div className="flex-1 min-w-0">
                  <div className="text-text font-medium">{c.contact ?? "—"}</div>
                  <div className="text-text-muted truncate">{c.preview ?? c.body ?? ""}</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </McpCard>
    </PanelScroll>
  );
}
